import Role from './Role';

const RoleNames = {
    /**
     * Dining activity type
     */
    primary: Role.Primary,

    /**
     * Dining activity type
     */
    secondary: Role.Secondary,
};

export default RoleNames;
